import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import LeftMenuSidebar from "../../../unicomponents/LeftMenuSidebar";
import TextLengthManagement from "./components/TextLengthManagement";

export default function ExtraSettings() {
  const { t } = useTranslation();

  const [activeMenu, setActiveMenu] = useState({
    menu_name: "text_length_management",
    menu_id: "text_length_management",
  });

  const menuData = [
    {
      item_name: "text_length_management",
      item_label:
        t("admin.extraSettings.textLengthManagement") || "글자수 제한 설정",
    },
  ];

  return (
    <div className="basicWidth">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-2">
            <LeftMenuSidebar
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              menuData={menuData}
              itemName="item_name"
              itemLabel="item_label"
            />
          </div>
          <div className="col-12 col-md-10">
            {activeMenu.menu_name === "text_length_management" && (
              <TextLengthManagement />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
